import { render, staticRenderFns } from "./MarketplaceCard.vue?vue&type=template&id=54a38cc2&"
import script from "./MarketplaceCard.vue?vue&type=script&lang=js&"
export * from "./MarketplaceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports